import { getShoppingData } from 'actions/shoppingData'
import { rest } from 'services'

export const removeCouponAction = couponCode => async dispatch => {
  try {
    await dispatch(getShoppingData(rest.api.removeCoupon, couponCode))
  } catch (e) {
    console.error(e)
  }
}
